// extracted by mini-css-extract-plugin
export default {"f":"_8ce811b0dc","main":"_1912bcb388","btn":"a390bc733a","w":"_65f7685814","h":"b9e23d9418","lh25":"_7e6830449f","wb":"_012a3b0649","b":"_080527c7df","bx":"d89fa3e3b6"};